<template>
  <div v-if="show" class="mt-5 pt-5 container">
    <div class="alert alert-warning mt-5 text-center" role="alert">
      <div>لطفا کمی صبرکنید...</div>
    </div>
  </div>
<div class="calendly-inline-widget my-5 pt-5" data-url="https://calendly.com/xaifin2024/30min" style="min-width:320px;height:700px;"></div>
</template>
<script>
import { defineComponent } from "vue";
import { onMounted, ref } from "vue";

export default defineComponent({
  components: {},
  setup() {
    const show = ref(true)

    onMounted(() => {
      const calendly = document.createElement("script");
        calendly.src = "https://assets.calendly.com/assets/external/widget.js";
        document.head.appendChild(calendly);
        calendly.onload
        setTimeout(() => {
          show.value = false
        }, 14000);
    })

    return {
      show
    };
  },
});
</script>
